export enum SearchParams {
  LocationId = "locationId",
  VisitId = "visitId",
}
